module.exports = __webpack_public_path__ + "img/pXiaDan.26d744a2.png";